var SupportAPIHelper, SupportOrderModel, SupportOrdersCollection, SupportOrdersFilterCollection, SupportUtilsHelper;

SupportAPIHelper = require('../helpers/API');

SupportOrderModel = require('../models/order');

SupportOrdersFilterCollection = require('./orders_filter');

SupportUtilsHelper = require('../helpers/utils');

SupportOrdersCollection = (function() {
  function SupportOrdersCollection() {
    this.hotelImages = {};
    this.orders = {};
  }

  SupportOrdersCollection.prototype.saveHotelImage = function(order) {
    var reservationSource;
    if (order.DEAL_TYPE === 'GETAWAYS_MARKET_RATE') {
      reservationSource = SupportUtilsHelper.getReservationSource(order);
      if (reservationSource) {
        return this.hotelImages[order.id] = {
          images: reservationSource.images
        };
      }
    }
  };

  SupportOrdersCollection.prototype.orderListPath = function(options) {
    var baseUrl, query, url;
    baseUrl = window.SUPPORTBASEURL + "/user/" + currentUser.id + "/orders";
    query = "";
    if (options.page != null) {
      query = query + "page=" + (encodeURIComponent(options.page)) + "&";
    }
    if (options.limit != null) {
      query = query + "limit=" + (encodeURIComponent(options.limit)) + "&";
    }
    if (options.sort_attribute != null) {
      query = query + "sort_attribute=" + (encodeURIComponent(options.sort_attribute)) + "&";
    }
    if (options.sort_order != null) {
      query = query + "sort_order=" + (encodeURIComponent(options.sort_order)) + "&";
    }
    return url = baseUrl + "?" + query;
  };

  SupportOrdersCollection.prototype.fetchOrders = function(options, successCallback, errorCallback) {
    var _successCb, url;
    options.sort_attribute || (options.sort_attribute = 'purchased_at');
    options.sort_order || (options.sort_order = 'descending');
    url = this.orderListPath(options);
    _successCb = (function(_this) {
      return function(response) {
        var ref;
        if ((response != null ? (ref = response.orders) != null ? ref.length : void 0 : void 0) > 0) {
          _this.updateOrderIndexDetails(response);
          return successCallback(response);
        } else {
          return successCallback(response || {});
        }
      };
    })(this);
    return SupportAPIHelper.get(url, null, _successCb, errorCallback, false);
  };

  SupportOrdersCollection.prototype.findOrderById = function(orderId) {
    if (this.hasOrders() && orderId) {
      orderId = orderId.toString();
      return this.orders[orderId];
    } else {
      return null;
    }
  };

  SupportOrdersCollection.prototype.setOrderSummary = function(order) {
    var orderId;
    if (order != null ? order.id : void 0) {
      orderId = order.id.toString();
      return this.orders[orderId] = order;
    }
  };

  SupportOrdersCollection.prototype.updateOrderIndexDetails = function(response) {
    _.each(response.orders, (function(_this) {
      return function(responseOrder) {
        var orderFound;
        orderFound = _this.findOrderById(responseOrder.id);
        if (orderFound) {
          return false;
        } else {
          _this.saveHotelImage(responseOrder);
          _this.setOrderSummary(responseOrder);
          return true;
        }
      };
    })(this));
    return response;
  };

  SupportOrdersCollection.prototype.hasOrders = function() {
    return _.size(this.orders) > 0;
  };

  SupportOrdersCollection.prototype.getNumberOfOrdersFetched = function() {
    return _.size(this.orders);
  };

  SupportOrdersCollection.prototype.getHotelImageByOrderId = function(orderId) {
    if (this.hasOrders()) {
      return this.hotelImages[orderId];
    } else {
      return null;
    }
  };

  SupportOrdersCollection.prototype.getFilterInstance = function(options) {
    var sort_attribute, sort_order;
    sort_attribute = options.sort_attribute, sort_order = options.sort_order;
    if (sort_attribute === 'purchased_at') {
      if (sort_order === "descending") {
        return this.createPurchaseDateDescendingFilter();
      } else {
        return this.createPurchaseDateAscendingFilter();
      }
    } else {
      if (sort_order === "descending") {
        return this.createMerchantNameDescendingFilter();
      } else {
        return this.createMerchantNameAscendingFilter();
      }
    }
  };

  SupportOrdersCollection.prototype.createPurchaseDateAscendingFilter = function() {
    var options;
    if (this.purchaseDateAscendingFilter) {
      return this.purchaseDateAscendingFilter;
    }
    options = {
      sort_attribute: "purchased_at",
      sort_order: "ascending"
    };
    return this.purchaseDateAscendingFilter = this.createFilter(options);
  };

  SupportOrdersCollection.prototype.createPurchaseDateDescendingFilter = function() {
    var options;
    if (this.purchaseDateDescendingFilter) {
      return this.purchaseDateDescendingFilter;
    }
    options = {
      sort_attribute: "purchased_at",
      sort_order: "descending"
    };
    return this.purchaseDateDescendingFilter = this.createFilter(options);
  };

  SupportOrdersCollection.prototype.createMerchantNameAscendingFilter = function() {
    var options;
    if (this.merchantNameAscendingFilter) {
      return this.merchantNameAscendingFilter;
    }
    options = {
      sort_attribute: "merchant_name",
      sort_order: "ascending"
    };
    return this.merchantNameAscendingFilter = this.createFilter(options);
  };

  SupportOrdersCollection.prototype.createMerchantNameDescendingFilter = function() {
    var options;
    if (this.merchantNameDescendingFilter) {
      return this.merchantNameDescendingFilter;
    }
    options = {
      sort_attribute: "merchant_name",
      sort_order: "descending"
    };
    return this.merchantNameDescendingFilter = this.createFilter(options);
  };

  SupportOrdersCollection.prototype.createFilter = function(options) {
    return new SupportOrdersFilterCollection(options);
  };

  return SupportOrdersCollection;

})();

module.exports = SupportOrdersCollection;

//# sourceMappingURL=data:application/json;base64,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
